export const openNewWindow = (url: string, windowWidth?: number, windowHeight?: number) => {
  const inputHeight = windowHeight || 480
  const inputWidth = windowWidth || 600

  const dualScreenLeft = window?.screenLeft !== undefined ? window?.screenLeft : window?.screenX
  const dualScreenTop = window?.screenTop !== undefined ? window?.screenTop : window?.screenY

  const width = window?.innerWidth ? window?.innerWidth : document?.documentElement?.clientWidth
  const height = window?.innerHeight ? window?.innerHeight : document?.documentElement?.clientHeight

  const systemZoom = width / window?.screen?.availWidth
  const left = (width - inputWidth) / 2 / systemZoom + dualScreenLeft
  const top = (height - inputHeight) / 2 / systemZoom + dualScreenTop

  window.open(
    url,
    '_blank',
    `toolbar=yes,scrollbars=yes,resizable=yes,width=${inputWidth},height=${inputHeight},top=${top},left=${left}`,
  )
}

export const openLink = (url: string) => window.open(url)
